import React from 'react';

import { HelpButton } from './styles';

interface HelpTooltipProps {
  /** Texto de ayuda. Ya traducido — este componente no llama a i18n. */
  text: string;
  className?: string;
}

/**
 * Icono de ayuda con burbuja, para aclarar un campo de formulario sin ocupar
 * una línea entera al lado del control.
 *
 * Pensado para ir **dentro de la etiqueta**, pegado a su texto. Por eso el
 * clic se corta: si no, al ir dentro de un `<label>` tocar el icono activaría
 * además el campo asociado (abriendo su desplegable, que es justo lo que
 * estorba). Sin `title`: lo pinta el CSS desde `data-tooltip`, y poner también
 * el atributo nativo saca DOS burbujas a la vez.
 */
export const HelpTooltip: React.FC<HelpTooltipProps> = ({
  text,
  className,
}) => (
  <HelpButton
    type="button"
    className={className}
    data-tooltip={text}
    aria-label={text}
    onClick={(e) => {
      e.preventDefault();
      e.stopPropagation();
    }}
  >
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden>
      <circle cx="7" cy="7" r="6" stroke="#666" strokeWidth="1" fill="#f0f0f0" />
      <path
        d="M7 3.5V4.5M7 6V10.5"
        stroke="#666"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <circle cx="7" cy="5" r="0.5" fill="#666" />
    </svg>
  </HelpButton>
);
